<template>
  <div>
    <VendorSelector />
    <DistrictSelector />
    <StudentSelector />
  </div>
</template>

<script>
import VendorSelector from './VendorSelector.vue'
import DistrictSelector from './DistrictSelector.vue'
import StudentSelector from './StudentSelector.vue'

import userManagementService from '../../../services/pages/userManagement.js'

export default {
  props: {},
  components: {
    VendorSelector,
    DistrictSelector,
    StudentSelector,
  },
  //beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {
    userManagementService.unregisterAllModals()
  },
}
</script>
